import DataUploadScreenLayout from "../../components/dataUploadLayout/dataUploadScreenLayout";

const MdmNew = () => {
    return (
        <>
            <DataUploadScreenLayout disableNext={true} />
        </>
    );
}

export default MdmNew;